import React from "react";
import ValmetLogo from "assets/valmetlogo.svg";
import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { ValmetWhite, ValmetGrey4, ValmetGrey3 } from "theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      display: "inline-block",
      marginLeft: "10px",
      flexGrow: 1,
      color: ValmetWhite,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
    navbar: {
      display: "flex",
      height: "60px",
      alignItems: "center",
      background: ValmetGrey4,
      [theme.breakpoints.down("sm")]: {
        height: "45px",
      },
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    logoBackground: {
      float: "right",
      display: "flex",
      height: "100%",
      width: "130px",
      alignItems: "center",
      justifyContent: "center",
      background: ValmetGrey3,
      [theme.breakpoints.down("sm")]: {
        width: "109px",
      },
    },
    logoContainer: {
      width: "146px",
      height: "43px",
      [theme.breakpoints.down("sm")]: {
        width: "87px",
        height: "31px",
      },
    },
    valmetlogo: {
      width: "100%",
    },
  }),
);

const TopBar = () => {
  const localClasses = useStyles();

  return (
    <div className={localClasses.navbar}>
      <Typography variant="h1" className={localClasses.title}>
        Valmet Recovery Boiler Combustion Diagnostics
      </Typography>
      <div className={localClasses.logoBackground}>
        <div className={localClasses.logoContainer}>
          <img src={ValmetLogo} alt="valmet logo" className={localClasses.valmetlogo} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TopBar);
